"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A browser-dependent implementation of setImmediate. We have performed
 * simple experiments to determine which implementation of setImmediate is
 * fastest on each browser. We use postMessage for any browser that we haven't
 * tested.
 */
const browser = require("detect-browser");
function makeSetImmediateMC() {
    const chan = new MessageChannel();
    // We can't send closures over MessageChannels.
    const chanThunks = [];
    chan.port2.onmessage = function (evt) {
        const func = chanThunks.pop();
        if (typeof func === 'function') {
            return func();
        }
        else {
            throw new Error(`makeSetImmediateMC expected a function, received: ${func}`);
        }
    };
    return (thunk) => {
        chanThunks.push(thunk);
        return chan.port1.postMessage(true);
    };
}
function setImmediateT0(thunk) {
    setTimeout(thunk, 0);
}
exports.setImmediateT0 = setImmediateT0;
function makeSetImmediatePM() {
    const thunks = [];
    window.addEventListener('message', (evt) => {
        if (evt.data === true) {
            const func = thunks.pop();
            if (typeof func === 'function') {
                return func();
            }
            else {
                throw new Error(`makeSetImmediatePM expected a function, received: ${func}`);
            }
        }
    });
    return (thunk) => {
        thunks.push(thunk);
        // NOTE(arjun): This likely conflicts with other uses of postMessage.
        window.postMessage(true, '*');
    };
}
function makeSetImmediate() {
    if (typeof self === "object" && typeof self.importScripts === 'function') {
        return setImmediateT0;
    }
    // browser can be null
    else if (!browser || browser.name === 'node') {
        return setImmediateT0;
    }
    else if (browser.name === 'safari') {
        return makeSetImmediateMC();
    }
    else if (browser.name === 'firefox') {
        return makeSetImmediateMC();
    }
    else if (browser.name === 'chrome') {
        return makeSetImmediatePM();
    }
    else if (browser.name === 'edge') {
        return makeSetImmediateMC();
    }
    else {
        console.warn(`Stopify has not been benchmarked with ${browser.name}. Defaulting to slow window.postMessage.`);
        return makeSetImmediatePM();
    }
}
exports.setImmediate = makeSetImmediate();
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./dist/src/runtime/setImmediate.js
// module id = 195
// module chunks = 0